import { useToasts } from "react-toast-notifications";
import { ContactElementModal } from "./ContactsContainer/ContactElementModal";
import { useModal } from "contexts/modalContext/modalContext";
import { CreateUserContact } from "components/Pages/Inbox/Contacts/ApiContactCalles";
import { useContent } from "contexts/contentContext/contentContext";

const plug = () => {};

const useAddContact = (onContactAdded: () => void) => {
  const { setModal, closeModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  const _handleSubmit = async (body: any) => {
    CreateUserContact({
      formBody: body,
      setContactList: plug,
      setContactsQuantity: plug,
      setCurrentPage: plug,
    }).then((res) => {
      if (res.status === "success") {
        //addToast success
        addToast(getTextByKey("success-add-contact"), {
          appearance: "success",
        });
        onContactAdded?.();
        //clean the form fields
      } else {
        //addToast error
        addToast(getTextByKey(res.data), {
          appearance: "error",
        });
      }
    });
    closeModal();
    return { status: "success" };
  };

  const addContact = () => {
    setModal({
      modal: ContactElementModal,
      modalSize: "full-modal",
      props: {
        isEdit: false,
        countFavoritesUsers: plug,
        handleSubmit: _handleSubmit,
      },
    });
  };

  return addContact;
};

export default useAddContact;
